import Vue from 'vue'
import firebase from '@/firebase'
import {parseDocument} from '@/utils/populations'

// Mapa de unsubscribes fuera del state reactivo de Vuex para evitar
// que los listeners de onSnapshot se acumulen sin liberarse.
const _unsubscribes = {}

export default {
  namespaced: true,
  state: {},
  actions: {
    updateProfile({state, commit}, profileId) {
      if (profileId && !_unsubscribes[profileId]) {
        _unsubscribes[profileId] = firebase.firestore
          .collection('profiles').doc(profileId)
          .onSnapshot((doc) => commit('SET_PROFILE', parseDocument(doc)))
      }
    },
    cleanup({ commit }) {
      Object.keys(_unsubscribes).forEach(id => {
        _unsubscribes[id]()
        delete _unsubscribes[id]
      })
    }
  },
  mutations: {
    SET_PROFILE (state, profile = {}) {
      Vue.set(state, profile.id, profile)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/profiles.js